export * from './update-minors-modal.component';
